import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative py-20 md:py-24 px-4 md:px-6 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Soft%20abstract%20gradient%20in%20warm%20coral%20peach%20and%20cream%20tones%2C%20flowing%20organic%20shapes%2C%20gentle%20overlapping%20curves%2C%20minimalist%20elegant%20composition%2C%20soft%20diffused%20lighting%2C%20healing%20wellness%20atmosphere%2C%20no%20sharp%20lines%2C%20dreamy%20ethereal%20quality%2C%20professional%20background%20texture&width=1800&height=600&seq=cta-bg-2026&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover object-top"
        aria-hidden="true"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>

      <div className="relative z-10 max-w-2xl mx-auto text-center">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50 mb-4">
          迈出第一步，让改变发生
        </h2>
        <p className="text-base text-background-200/90 mb-8 leading-relaxed">
          无论您正在经历怎样的困扰，都有一条通往更好的路。
          <br />
          我们的专业顾问团队随时准备陪伴您走好每一步。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/about#contact"
            className="whitespace-nowrap px-8 py-3.5 rounded-full bg-primary-500 text-background-50 text-base font-medium hover:bg-primary-600 transition-all duration-200"
          >
            立即预约咨询
          </Link>
          <Link
            to="/category/xing-jian-kang-jiao-yu"
            className="whitespace-nowrap px-8 py-3.5 rounded-full border border-background-300/40 text-background-200 text-base font-medium hover:bg-background-50/10 transition-all duration-200"
          >
            浏览知识文章
          </Link>
        </div>
      </div>
    </section>
  );
}